export default __webpack_public_path__ + "static/Leeuwin-Estate-67358e5ce4e86a199be61ec69c3eecb2.jpg";